import { createFormActions, createInput, createInputFile, createSelect } from ":ui/form";
import type { UserRequests } from "../../SHARED/_model";

export function createTeamInputs(props: UserRequests["team_info"]) {
  const TeamName = createInput<string>(props?.name, {
    required: true,
    validators: (value: string) => {
      if (value != undefined) {
        if (value.length < 6) {
          return { ["at least 6 characters"]: true };
        }
        if (value.length >= 30) {
          return { ["at most 30 characters"]: true };
        }
      }
      return undefined;
    },
  });
  const Track = createSelect(props?.track, { required: true });
  const Brief = createInput(props?.brief, { required: false });
  const Thumbnail = createInputFile(null, { required: false });

  const Actions = createFormActions(
    {
      TeamName,
      Track,
      Brief,
      Thumbnail,
    },
    {
      defaultCase: "snake",
    }
  );
  return {
    Actions,
    TeamName,
    Track,
    Brief,
    Thumbnail,
  };
}
